import { I18N_CACHE_PREFIX } from './getI18nCacheKey';

/**
 * Removes corrupted cached translations from localStorage.
 *
 * AsyncLocalStorageBackend is the primary backend in the chain, so an entry that
 * fails to parse blocks the namespace from ever loading. Must run before i18n.init().
 * `-lastmodified` entries hold a raw date string rather than JSON, so they are skipped.
 */
export const removeInvalidI18nCache = () => {
  Object.keys(localStorage).forEach((key) => {
    if (!key.startsWith(I18N_CACHE_PREFIX) || key.endsWith('-lastmodified')) {
      return;
    }

    const cachedData = localStorage.getItem(key);
    if (!cachedData) {
      localStorage.removeItem(key);
      return;
    }

    try {
      JSON.parse(cachedData);
    } catch (e) {
      localStorage.removeItem(key);
      console.error(`Removed invalid cached translation ${key} from localStorage.`, e);
    }
  });
};
